import React from "react";
import { Col, Row } from "react-flexbox-grid";
import FormGroup from "@material-ui/core/FormGroup";
import _ from "lodash";
import TagValueItem from "./tag-value-item";
import { Typography, Divider } from "@material-ui/core";

const TagItem = ({ tag, onChange = _.noop, isChecked = _.noop }) => {
	const { name, values = [], id } = tag;

	const valuesComponent = _.sortBy(values, "value")
		.filter((value) => value.availableStatsCount !== 0)
		.sort()
		.map((item, key) => {
			return (
				<React.Fragment key={key}>
					<TagValueItem
						key={item.value}
						tagId={id}
						item={item}
						onChange={onChange}
						isChecked={isChecked}
					/>
					<Divider />
				</React.Fragment>
			);
		});

	return (
		<Row start="xs" className=" border m-4 rounded p-3">
			<Col xs={12} className="h-10 max-h-10 mb-4">
				<div className="text-xl mb-2">{name}</div>
				<Divider />
			</Col>
			<Col xs={12}>
				{valuesComponent.length > 0 ? (
					<FormGroup>{valuesComponent}</FormGroup>
				) : (
					<Typography variant="caption">
						Sin recursos estadísticos...
					</Typography>
				)}
			</Col>
		</Row>
	);
};

export default TagItem;



// WEBPACK FOOTER //
// ./src/components/tags-manager/tag-values-selector/tag-item.js